jQuery(document).on('page.ready', function () {
    $ = jQuery;

    if ($('main.gestures-page').length) {
        console.log('Gestures page JS');
        /*** MODAL FOR GESTURES VIDEOS ***/
        function getIDfromYouTubeURL(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            var match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
        }

        $('.gvids').click(function () {
            $('html').addClass('playlist-modal-open');
            $('.gestures-modal .player').html('<iframe src="https://www.youtube.com/embed/' + getIDfromYouTubeURL($(this).data('vid')) + '?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
        });
        /*** END MODAL FOR GESTURES VIDEOS ***/

        var Params = (function (strParam) {
            var objParams = {};

            function pullParams() {
                // get url parameters
                var arrURLParams = window.location.search.replace('?', '').split('&');
                // obj placeholder for params
                objParams = {};
                // convert parameters into an object
                arrURLParams.map(function (val) {
                    var arrPair = val.split('=');
                    if (!arrPair[0]) { return false };
                    objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
                });
            }

            function getParam(strParam) {
                pullParams();

                return objParams[strParam];
            }

            function setParam(name, value) {
                pullParams();

                var newParams = objParams;

                if (value === null) {
                    delete newParams[name];
                } else {
                    newParams[name] = value;
                }

                var paramsURL = Object.keys(newParams).map(function (key, val) { return [key, newParams[key]].join('=') }).join('&');

                var newURL = location.pathname;
                if (paramsURL.length) { newURL += "?" + paramsURL; }
                window.history.replaceState(null, null, newURL);

            }
            console.log(objParams);

            return {
                get: getParam,
                set: setParam
            }
        }());

        function goToGestureSection(topic) {
            Params.set('topic', topic.name);
            window.history.pushState({}, '', new URL(window.location));
            $('html,body').animate({ scrollTop: gestureIntroPos - ($('#nav-bar').height()) }, 500, 'swing');

            setTimeout(function () {
                $gintro.flickity('select', topic.id);
            }, 650);
        }

        function closeGesturesPopup(e) {
            $('#gestures-start').addClass('enabled');
            $('header.gestures').addClass('passed');

            $('html,body').removeClass('noscroll').animate({
                scrollTop: gestureIntroPos - ($('#nav-bar').height())
            }, 800, 'swing');

            if ($('header.gestures').hasClass('wait')) {
                $('header.gestures').removeClass('wait');
            }
        }

        var gestureIntroPos = 0;
        var smcontroller = new ScrollMagic.Controller();

        var topic = Params.get('topic');
        var age = Params.get('age');
        var env = Params.get('env');

        // Reset SMController for new page
        smcontroller.destroy(true);
        smcontroller = new ScrollMagic.Controller();

        setTimeout(function () {
            $('header.gestures').addClass('is-loaded');
            gestureIntroPos = $('section.gesture-intro').offset().top;

            if (age) { $('#age').val(age).trigger('change'); }
            if (env) { $('#env').val(env).trigger('change'); }
            if (topic) {
                console.log(topic);
                setTimeout(function () {

                    if (!age) { $('#age').val('any').trigger('change') }
                    if (!env) { $('#env').val('any').trigger('change') }

                    $('.gnav button[data-topic="' + topic + '"]').trigger('click');
                }, 1000);
            }

        }, 1000);

        $('header.gestures').each(function () {

            var heightOne = ($('.content-one').height() / 2),
                heightTwo = ($('.content-two').height() / 2);

            var classChange = new TimelineMax()
                .to($('.dynamic'), 0, {
                    height: '10vw'
                })
                .to($('.dynamic .content-one'), 0, {
                    opacity: '1',
                    position: 'relative',
                    y: '-50%',
                    ease: Power0.easeNone
                })
                .call(function () {
                    $('header.gestures .bg').toggleClass('darken');
                })
                .to($('.dynamic .content-two'), 1, {
                    opacity: '1',
                    position: 'relative',
                    y: -heightTwo,
                    ease: Power0.easeNone
                }, "+=0.25")
                .call(function () {

                    if ($('header.gestures').hasClass('passed')) {

                    } else {
                        $('html,body').addClass('noscroll');
                        $('header.gestures').addClass('passed');
                        $('header.gestures').addClass('wait');
                        setTimeout(function () {
                            $('html,body').animate({ scrollTop: gestureIntroPos - (($('#nav-bar').height() + $('section.gesture-intro').height())) }, 100, 'swing');
                        }, 88);
                    }

                })
                .to($('.dynamic .content-one'), 0.25, {
                    opacity: '0',
                    position: 'absolute',
                    y: '-52%'
                }, "-=1");

            new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 0,
                    duration: '150%'
                })
                .setPin(this)
                .setTween(classChange)
                .addTo(smcontroller);
        });

        $('#age, #env').on('change', function (event) {
            var $this = $(this);

            if ($('#age').val() !== 'any' || $('#env').val() !== 'any') {
                $('.gesture-intro').hide();
            } else {
                $('.gesture-intro').show();
            }

            if ($this.val() !== '?' && $this.val() !== 'any') {
                Params.set($this.attr('id'), $this.val().replace(' ', '-'));
            } else {
                // remove param
                Params.set($this.attr('id'), null);
            }

            if ($this.hasClass('q')) {
                $this.removeClass('q');
            }

            if ($this.val() == '?') {
                $this.addClass('q');
            } else {
                /* Grabs the Widths of an H2 with matching text from div.content-mirror and sets the width of the <select> to match
                 * --
                 */
                var theselect = $this,
                    value = $(theselect).val(),
                    findWidths = $('.content-mirror').children();
                $(findWidths).each(function (index, el) {
                    var lenElem = $(el).data('len');

                    if (lenElem == value) {
                        $(theselect).css('width', $(el).width());
                    }

                });

                /* Adds a class of .enabled to the button when both <selects have values not equal to the ?
                 * --
                 */
                if ($('#age').val() != '?' && $('#env').val() != '?') {
                    $('#gestures-start').addClass('enabled');
                }

            }

        });

        $('#age').on('change', function (event) {

            var value = $(this).val();

            /* Shows all age-tiers that match the dropdown
             * --
             */
            var ages = value;
            if (value == '?' || value == 'any') {
                ages = '?';
                $('.age-related').addClass('hidden');
            } else {
                $('.age-related').removeClass('hidden');
            }

            $('.age-tier').each(function (index, el) {
                if ($(el).hasClass(ages)) {
                    $(el).addClass('showing');
                } else {
                    $(el).removeClass('showing');
                }
            });
        });

        $('#env').on('change', function (event) {

            var value = $(this).val();

            /* Shows all env-tiers that match the dropdown
             * --
             */
            var envs = value;
            if (value == '?' || value == 'any') {
                envs = '?';
                $('.env-related').addClass('hidden');
            } else {
                $('.env-related').removeClass('hidden');
            }

            $('.env-tier').each(function (index, el) {
                if ($(el).hasClass(envs)) {
                    $(el).addClass('showing');
                } else {
                    $(el).removeClass('showing');
                }
            });
        });

        $('#gestures-start').click(closeGesturesPopup);

        /*
         * Gestures Intro Section
         *  – controls most of the dynamic logic for content of page from the .on change of flickity
         */
        $gintro = $('.gesture-intro .container');
        $gintro.flickity({
            cellAlign: 'center',
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            adaptiveHeight: true,
            selectedAttraction: 0.02,
            friction: 0.22
        }).on('change.flickity', function (event, index) {
            /** Filtering of content on change of Flickity **/

            var gestures1 = $('.why-it-works .container').children(),
                gestures2 = $('.age-related .container').children(),
                gestures3 = $('.env-related .container').children(),
                gestures4 = $('.references .container').children(),
                gestures5 = $('.next .container').children(),
                gestures6 = $('aside.gnav .container').children();

            $(gestures1).removeClass('active');
            $(gestures2).removeClass('active');
            $(gestures3).removeClass('active');
            $('.references .container').css('height', '0').removeClass('active');
            $('.references button').removeClass('show');
            $(gestures4).removeClass('active');
            $(gestures5).removeClass('active');
            $(gestures6).removeClass('active');

            $(gestures1[index]).addClass('active');
            $(gestures2[index]).addClass('active');
            $(gestures3[index]).addClass('active');
            $(gestures4[index]).addClass('active');
            $(gestures5[index]).addClass('active');
            $(gestures6[index]).addClass('active');

            /** END filtering of content on change of Flickity **/
        });

        $('.gnav button').click(function (e) {
            var btnIndex = $(this).index();

            closeGesturesPopup(e);
            goToGestureSection({ id: btnIndex, name: this.dataset.topic });
        });
        $('.icons button').click(function (e) {
            var btnIndex = $(this).index();
            var $age = $('#age');
            var $env = $('#env');

            $('#age, #env').val('any').trigger('change');

            closeGesturesPopup(e);
            goToGestureSection({ id: btnIndex, name: this.dataset.topic });
        });

        $('.nextbtn').click(function (event) {
            var btnIndex = $(this).parent().index() + 1;
            console.log(btnIndex);

            Params.set('topic', $(this).attr('data-next'));

            $('html,body').animate({ scrollTop: gestureIntroPos - ($('#nav-bar').height()) }, 500, 'swing');

            setTimeout(function () {
                $gintro.flickity('select', btnIndex);
            }, 650);
        });

        $('.gestures-container').each(function () {
            var height1 = $('.gestures-container').height(),
                height2 = $('aside.gnav').height(),
                height3 = $('.gestures-container').children().last().height(),
                height4 = (height1 - height2 - (height3 / 2));

            new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 0,
                    duration: height4
                })
                .setClassToggle('aside.gnav', 'active')
                .setPin('aside.gnav')
                .addTo(smcontroller);

            if ($(window).width() > 950) {
                $('aside.gnav .container').css('height', $('section.gesture-intro').height());
            }
        });

        $('.references button').click(function (event) {

            if (!$(this).hasClass('show')) {
                $(this).addClass('show');
                var heightOfActive = $(this).siblings().children('.active').outerHeight(true);
                $(this).siblings().css('height', heightOfActive).addClass('active');
            } else {
                $(this).siblings().css('height', 0).removeClass('active');
                $(this).removeClass('show');
            }

        });

        $('.card').each(function () {
            var me = $(this);

            new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 0.7
                })
                .on('enter', function (event) {

                    if ($(me).parent().parent().parent().parent().hasClass('active')) {
                        $(me).addClass('visible');
                    }

                })
                .addTo(smcontroller);
        });

        $('a[href="#reflink"]').click(function (event) {
            $('html,body').animate({ scrollTop: $('section.references').offset().top - ($('#nav-bar').height()) }, 800, 'swing');
            setTimeout(function () {
                $('section.references button').trigger('click');
            }, 650);
        });

    } //end page check
});